import { gql } from 'apollo-angular';

export const BRANCH_IMAGE_FRAGMENT = gql`
  fragment BranchImageFragment on Branch {
    id
    imageUrls {
      download
      upload
    }
  }
`;
